import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem, WriteFileResult } from '@capacitor/filesystem';
import { CapacitorPlatformEnum } from './capacitor-platform.enum';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';

export class CapacitorUtils {
  static readonly isApp = Capacitor.getPlatform() !== CapacitorPlatformEnum.WEB;

  // TODO: need to fix type
  static async writeAndOpenFile(data: Blob, fileName: string, type: string = 'pdf', currentFormat?: string): Promise<void> {
    try {
      const format = currentFormat ?? (type === 'pdf' ? '.html' : '.p7s');
      const filePath: string = fileName + format;
      const dataURL: string = await this.blobToDataURL(data);

      await Filesystem.writeFile({
        path: fileName.includes('.') ? fileName : filePath,
        data: dataURL,
        directory: Directory.Documents,
        recursive: true,
      }).then((data: WriteFileResult) => {
        FileOpener.openFile({
          path: data.uri,
        });
      });
    } catch (error) {
      console.error(error);
    }
  }

  static async blobToDataURL(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          resolve(reader.result);
        } else {
          reject(new Error('Failed to convert Blob to Data URL.'));
        }
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(blob);
    });
  }

  static async downloadAndOpenFile(link: string, fileName: string, currentType: string = '.pdf'): Promise<void> {
    if (CapacitorUtils.isApp) {
      try {
        const response = await fetch(link);
        const blob = await response.blob();
        await CapacitorUtils.writeAndOpenFile(blob, fileName, 'pdf', currentType);
      } catch (error) {
        console.log(error);
      }
      return;
    }
    window.open(link, '_blank');
  }
}
